import {
  BaseHeader,
  EmptyHeader,
  SortableHeader,
  SummaryTitleHeader,
  TitleHeader,
} from 'features/dashboard/table/column/DashboardHeaders'
import {
  AdGroupCell,
  CampaignCell,
  CampaignTypeCell,
  DateCell,
  IdCell,
  OperationStatusCell,
  ReviewStatusCell,
} from 'features/dashboard/table/column/DashboardCells'
import { CreativeNameCell } from './CreativeCells'
import {
  metricColumns,
  selectionColumn,
  statusColumn,
} from 'features/dashboard/table/column/DashboardColumns'
import { EtcColumns, GeneralColumns } from '../../../../Columns'

/**
 * @file 소재 테이블 칼럼
 * @see https://wiki.daumkakao.com/pages/viewpage.action?pageId=818963416
 */

export const CreativeFixedColumns = [
  selectionColumn,
  {
    accessor: 'name',
    sticky: 'left',
    Header: TitleHeader,
    columns: [
      {
        accessor: 'name',
        width: 370,
        Header: SummaryTitleHeader,
        Cell: CreativeNameCell,
      },
    ],
  },
  statusColumn,
]

export const CreativeConfigurableColumns = [
  {
    accessor: GeneralColumns.operationStatus.name,
    Header: BaseHeader,
    title: GeneralColumns.operationStatus.displayName,
    tooltip: (
      <>
        소재 게재와 관련된 현재 상태를 의미합니다.
        <br />
        상위 광고그룹의 상태를 고려하여 현재 소재의 최종 운영 상태를 표기합니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.operationStatus.name,
        width: 180,
        Header: EmptyHeader,
        Cell: OperationStatusCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.campaignType.name,
    Header: SortableHeader,
    title: GeneralColumns.campaignType.displayName,
    tooltip:
      '캠페인 유형을 통하여 원하는 목표를 달성하는데 적합한 캠페인, 광고그룹, 키워드, 소재 설정을 제공합니다.',
    columns: [
      {
        accessor: GeneralColumns.campaignType.name,
        width: 130,
        Header: EmptyHeader,
        Cell: CampaignTypeCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.reviewStatus.name,
    Header: BaseHeader,
    title: GeneralColumns.reviewStatus.displayName,
    tooltip: '소재의 심사와 관련된 현재 상태를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.reviewStatus.name,
        width: 130,
        Header: EmptyHeader,
        Cell: ReviewStatusCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.campaign.name,
    Header: BaseHeader,
    title: GeneralColumns.campaign.displayName,
    tooltip: '소재가 소속된 캠페인을 표기합니다.',
    columns: [
      {
        accessor: GeneralColumns.campaign.name,
        width: 330,
        Header: EmptyHeader,
        Cell: CampaignCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.adGroup.name,
    Header: BaseHeader,
    title: GeneralColumns.adGroup.displayName,
    tooltip: '소재가 소속된 광고그룹을 표기합니다.',
    columns: [
      {
        accessor: GeneralColumns.adGroup.name,
        width: 330,
        Header: EmptyHeader,
        Cell: AdGroupCell,
      },
    ],
  },
  {
    accessor: EtcColumns.creativeLinkId.name,
    Header: SortableHeader,
    title: EtcColumns.creativeLinkId.displayName,
    tooltip: '소재가 광고그룹에 연결된 고유의 식별값을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.creativeLinkId.name,
        width: 160,
        Header: EmptyHeader,
        Cell: IdCell,
      },
    ],
  },
  {
    accessor: EtcColumns.creativeId.name,
    Header: SortableHeader,
    title: EtcColumns.creativeId.displayName,
    tooltip: '소재 마다 부여된 고유의 식별값을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.creativeId.name,
        width: 160,
        Header: EmptyHeader,
        Cell: IdCell,
      },
    ],
  },
  {
    accessor: EtcColumns.createdDate.name,
    Header: SortableHeader,
    title: EtcColumns.createdDate.displayName,
    tooltip: '소재가 광고그룹에 최초 등록된 시간을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.createdDate.name,
        width: 130,
        Header: EmptyHeader,
        Cell: DateCell,
      },
    ],
  },
  ...metricColumns,
]
